'use client';

import { memo } from 'react';
import { GlowSkeleton } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';

export const SearchSuggestSkeleton: ComponentMemo = memo(() => {
    return (
        <>
            <GlowSkeleton width={'70%'} height={'2rem'} containerClassName={'w-full'} />
            <GlowSkeleton width={'50%'} height={'2rem'} containerClassName={'w-full'} />
            <GlowSkeleton width={'40%'} height={'2rem'} />
            <GlowSkeleton width={'60%'} height={'2rem'} />
        </>
    );
});

SearchSuggestSkeleton.displayName = 'SearchSuggestSkeleton';
